import { TThunkAction } from '../../types/redux';
import { subscribeOnAuthentification } from './authenticationUtils';
import { IRequestAuthenticationParameters } from './types';

export function requestAuthentication(parameters?: IRequestAuthenticationParameters): TThunkAction {
  return (dispatch, _getState, context) => {
    const { microfrontendsAPI } = context;

    if (!microfrontendsAPI) {
      return;
    }

    const shouldSubscribe = Boolean(parameters?.onSuccess || parameters?.onCloseNoAuth);
    const unsubscribe = shouldSubscribe ? dispatch(subscribeOnAuthentification(parameters)) : () => undefined;
    const handleError = (error: unknown) => {
      unsubscribe();
      const normalizedError = error instanceof Error ? error : new Error(String(error));

      context.logger.error(normalizedError, {
        domain: 'requestAuthentication',
        message: 'Не удалось открыть окно авторизации',
      });
    };

    try {
      void microfrontendsAPI.header
        .openAuthModal({
          autoRefresh: !parameters?.onSuccess,
          alert: parameters?.alert ?? null,
          useDefaultView: false,
          viewData: parameters?.viewData ?? null,
          source: parameters?.source ?? null,
        })
        .catch(handleError);
    } catch (error) {
      handleError(error);
    }
  };
}
